<template>
  <v-overlay :value="loading" color="primary" v-if="loading && !hub" :opacity="1" class="text-center">
        <v-progress-circular indeterminate size="64"></v-progress-circular><br>
        <v-card-subtitle class="pt-5">Gegevens ophalen</v-card-subtitle>
      </v-overlay>
  <v-sheet v-else
    :dark="dark"
    class="fill-height"
    :color="!dark ? 'background' : null"
  >
  
  <v-overlay :value="loading" color="primary" v-if="loading" class="text-center">
        <v-progress-circular indeterminate size="64"></v-progress-circular><br>
        <v-card-subtitle class="pt-5">Laden...</v-card-subtitle>
      </v-overlay>
   
     <onboarding type="home" v-if="isEmpty && !showSearch && !this.address" :show="isEmpty" mandatory> 
       <template v-slot:content="{ step }">
         <v-card-text class="mx-5 text-center">
         <center><collect-code dark show @success="showSearch=true" :size="5" color="primary" text="Klik hier" placeholder="_ _ _ _ _ _ _ _ _" class="mt-5"  v-if="step==0" @active="setCodeActive">
         
         </collect-code></center>
         </v-card-text>
       </template>
        <template slot="buttons">
        <!--v-btn text @click="showSearch=true" class="ma-5" :disabled="codeActive">overslaan</v-btn-->
         <v-spacer></v-spacer>
         <v-btn text @click="showSearch=true" v-if="codeActive">Overslaan</v-btn>
         <v-btn text @click="showSearch=true" v-else>Volgende</v-btn>
        </template>
    </onboarding>
   
       <address-block popup v-else-if="showSearch && !loading"
              allow-delete :list-hubs="hublist.length==0"
              :show="showSearch && !loading"
              v-model="search" :browse="browse"
              
              @select="selectAddress"
              @close="closeSearch"
              @add-host="showAddHost=true"
            >
            </address-block>
   <!--v-card outlined class="ma-3" v-if="isEmpty" dark color="primary">
                <v-card-title>Welkom</v-card-title>

               <v-card-text>Er is nog geen eetplein bij je in de buurt gevonden. </v-card-text>
               <center><v-btn text @click="showSearch=true">Eetplein zoeken</v-btn></center>
               <v-card-text>Als je een actiecode hebt gekregen van je favoriete eettent dan kun je die hier invullen. Je krijg dan alvast gratis stempels en kunt gelijk bestellen.
            </v-card-text>
           <v-card-title class="justify-center" >
           <collect-code @succes="reloadMe(true)" text="Vul je actie code in." placeholder="Actiecode"></collect-code>
          </v-card-title>
          </v-card-->
    <template>
    <page-header 
      :class="{ custom: selectedHub && selectedHub.banner ? true : false }"
      v-model="drawer"
      :banner-height="bannerHeight"
      :is-toolbar="isToolbar"
      :banner="banner"
      :no-gradient="true"
      :title="title"
      :title-icon="titleIcon"
      
    >

      <template slot="hero" v-if="!loading">
         <eetplein
          v-if="selectedHub"
          :street="test ? 'mijn testplein' : 'mijn eetplein'"
          :city="selectedHub.name"
          :elevation="0"
          @click="showSearch = true;"
          append-icon="expand_more"
        >
        </eetplein>
         <eetplein
          v-else-if="address"
          :street="test ? 'mijn testplein' : 'mijn eetplein'"
          :city="address.city"
          :elevation="0"
          @click="showSearch = true;"
          append-icon="expand_more"
        >
        </eetplein>
        
        <eetplein
          v-else
          :street="test ? 'mijn testplein' : 'mijn eetplein'"
          city="KIES"
          :elevation="0"
          @click="showSearch = true;"
          append-icon="expand_more"
        >
        </eetplein>
        <v-spacer></v-spacer>
      </template>
      <v-btn slot="button" v-if="tabs==1" @click="$refs.actioncode.edit()" color="primary">
        <v-icon class="mr-1">closed_caption</v-icon>
        Actie code</v-btn>
      
      
      <template slot="extension" v-if="selectedHub && tabs == 0  && courier">
      <v-toolbar
        flat
        :dark="dark"
        :light="!dark" dense
       :class="{'rounded-lg rounded-t-0': largeScreen}" 
      > <v-btn icon class="mx-2"><v-icon>mdi-bike-fast</v-icon></v-btn>
        <v-toolbar-title class="px-0">Ophaalservice</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-switch class="ma-3" v-model="showAllDeliveries" label="Alles"></v-switch>
      </v-toolbar>
      
      </template>
      <template slot="extension" v-if="selectedHub && tabs == (0 + courier?1:0) && hostlist.length>0">
      <v-toolbar
        flat
        :dark="dark"
        :light="!dark" dense
        class="pr-0" 
        :class="{'rounded-lg rounded-t-0': largeScreen}" 
      >
      
        <v-chip-group v-model="model"
        :class="{'ml-3': tabs.length==1}" column center-active
        active-class="primary" mandatory class="mx-auto">
         <swiper  ref="chipMenu" :options="menuSwiperOptions">
          <swiper-slide style="width:100px"
            v-for="(type, i) in menus" class="text-subtitle-1 text-center"
            :key="i"
          >
         <v-chip
              label
              :dark="model == type"
              :value="type"
              :key="i"
              style="background-color: transparent;"
              class="text-body-1 mx-0"
            >
              {{ getGroupName(type) }}
            </v-chip>
          </swiper-slide>
          <swiper-slide style="width:200px"
          ></swiper-slide>
          </swiper>
        </v-chip-group>
      </v-toolbar>
     
      </template>
      <!--template slot="icon" v-if="largeScreen">
          <v-chip to="./settings" label color="transparent" dark large><v-icon left class="mr-1">person</v-icon>{{user.name ? user.name : user.phone}}</v-chip>
      </template-->
    </page-header>
    <v-container class="pa-0 main-content">
      <footer-info v-if="!largeScreen"
                v-model="tabs"
                :clubs="clublist"
                :stamps="stampsaction.length"
                :orders="orderlist"
                :deliveries="deliveries.filter(d=>!d.done)"
              ></footer-info>
     <main-menu v-if="!largeScreen" v-model="drawer" :address="address" :scrollTop="scrollTop" :dark="dark" @settings="showSearch = true"
                :orders="orderlist.length"
                :permanent="largeScreen"
                :temporary="!largeScreen"
                :deliveries="deliveries.filter(d=>!d.done).length"></main-menu>
    <v-row class="mt-5">
      <v-col cols="4" v-if="largeScreen">
         <main-menu v-model="drawer" :address="address" :scrollTop="scrollTop" :dark="dark" @settings="showSearch = true"
                :orders="orderlist.length"
                :permanent="largeScreen"
                :temporary="!largeScreen"
                :outlined="largeScreen" class="mt-2 rounded-lg"
                style="border:1px solid rgba(0,0,0,0.12);width:100%;" floating
                :deliveries="deliveries.filter(d=>!d.done).length"></main-menu>
      </v-col>
      <v-col :cols="largeScreen ? 8 : 12">
        <v-card
          tile
          class="mx-auto pb-15 pt-2 "
          flat
          color="transparent"
          :loading="loading"
        >
      
          <template v-if="loading">
            <v-skeleton-loader
              class="ma-3"
              type="list-item"
              v-for="i in 10"
              :key="i"
            ></v-skeleton-loader>
          </template>
          <v-window v-model="tabs" touchless v-if="!loading" class="pb-15" :class="{'ml-5': largeScreen}">
          <v-window-item v-if="courier">
              <Couriers v-if="courier" :show-all="showAllDeliveries"></Couriers>
            </v-window-item>
            <v-window-item class="masonry-with-columns" >
            
              <template v-if="ordernow.length > 0">
                <v-card-title
                  class="primary--text font-weight-light pl-5 pt-0"
                  >Je bestelling<template v-if="ordernow.length > 1">en</template> </v-card-title>
                <order-card v-for="order in ordernow"
                  :dark="dark"
                  :key="order._id"
                  :order="order" 
                  @select="selectOrder" class="mx-2"
                ></order-card>
                
                </template>


              <template v-if="model == 'favorite'">
                <v-card-title
                  class="primary--text font-weight-light pl-5"
                  v-if="discounts.length > 1"
                  >Acties van vandaag</v-card-title
                >
                  <v-card-title
                  class="mt-4 primary--text font-weight-light pl-5"
                  v-if="discounts.length == 1"
                  >Actie van vandaag</v-card-title
                >
                 <template v-if="largeScreen"> 
                    <v-card outlined v-for="(discount, n) in discounts" :key="n" :dark="discount.dark" 
                    :color="discount.color" class="success--border mb-3" :class="{'mx-2' : !largeScreen}" 
                    >
                    <v-list-item @click="selectDiscount(discount)" :color="discount.color" :dark="dark || discount.dark" style="border-right: 10px solid green">
                        <v-list-item-avatar color="white" v-if="discount._host.logo"><v-img :src="discount._host.logo"></v-img></v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title :class="{'primary--text': !discount.dark}">{{discount.name}}</v-list-item-title>
                            <v-list-item-subtitle><b>{{discount.description}}</b><br>{{discount._host.name}}</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action v-if="discount.stamps && discount.extra" class="text-h6">{{discount.extra}}</v-list-item-action>
                        <v-list-item-action v-if="discount.percentage" class="text-h6">{{discount.percentage}}%</v-list-item-action>
                        <v-list-item-action v-else-if="discount.price" class="text-h6">{{discount.price | toCurrency}}</v-list-item-action>
                        <v-list-item-action v-else-if="discount.discount" class="text-h6">{{discount.discount | toCurrency}}</v-list-item-action>
                      </v-list-item>
                    </v-card>
                    </template>
                <swiper ref="mySwiper" :options="swiperOptions" v-else>
                  <swiper-slide v-for="(discount, n) in discounts" :key="n" class="py-2">
                    <v-card :outlined="!largeScreen" :dark="discount.dark" :color="discount.color" class="success--border" :class="{'ml-2' : n==0 && discounts.length > 1, 'mx-3' : largeScreen}">
                    <v-list-item @click="selectDiscount(discount)" :color="discount.color" :dark="dark || discount.dark" style="border-right: 10px solid green">
                        <v-list-item-avatar color="white" v-if="discount._host.logo"><v-img :src="discount._host.logo"></v-img></v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title :class="{'primary--text': !discount.dark}">{{discount.name}}</v-list-item-title>
                            <v-list-item-subtitle><b>{{discount.description}}</b><br>{{discount._host.name}}</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action v-if="discount.stamps && discount.extra" class="text-h6">{{discount.extra}}</v-list-item-action>
                        <v-list-item-action v-if="discount.percentage" class="text-h6">{{discount.percentage}}%</v-list-item-action>
                        <v-list-item-action v-else-if="discount.price" class="text-h6">{{discount.price | toCurrency}}</v-list-item-action>
                        <v-list-item-action v-else-if="discount.discount" class="text-h6">{{discount.discount | toCurrency}}</v-list-item-action>
                      </v-list-item>
                    </v-card>
                  </swiper-slide>
                  
                  <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
                
                <v-card-title
                  class="mt-4 primary--text font-weight-light pl-5"
                  v-if="discounts.length > 0 || ordernow.length > 0"
                  >Restaurants</v-card-title
                >
              </template>
              <v-card flat v-if="hosts.length>0" :color="selectedHub && model !== 'favorite' || search || hosts.length==1 || largeScreen? 'transparent' : null">
                <v-divider v-if="(!selectedHub ||model == 'favorite') && !search && hosts.length>1 && !largeScreen"></v-divider>
              <template v-for="(host, i) in hosts">
                <template v-if="host._id.includes('hub')">
                  <hub-card
                    :dark="dark"
                    :deliver="type == 'deliver'"
                    :key="'t' + host._id + i"
                    class="mx-3 mb-5"
                    :value="host"
                    outlined
                    @select="showHub"
                  ></hub-card>
                </template>
                <organisation-card v-else
                  :dark="dark"
                  :compact="model == 'favorite' && !search && !largeScreen && hosts.length>1"
                  :search="search ? true : false"
                  :deliver="type == 'deliver'"
                  :key="'t' + host._id + i"
                  :class="{'mx-3 mb-5': model !== 'favorite' || search ||  hosts.length==1 || largeScreen}"
                  :value="host"
                  outlined
                  :distance="host.distance"
                  @select="openHost($event)"
                ></organisation-card>
                <v-divider :key="'l' + host._id + i" v-if="selectedHub && model == 'favorite' && !search && hosts.length>1 && !largeScreen"></v-divider>
              </template>
              </v-card>
              <empty dense v-if="hosts.length==0 && model == 'favorite'" icon="favorite" text="Favorieten" description="Je hebt nog geen favorieten ingesteld. Doe een bestelling of markeer je favoriete restaurant via het hartje.">
                </empty>
              <add-host v-model="showAddHost" type="RELATIONS" @success="addHostToList"></add-host>
              
            </v-window-item>
            <v-window-item >
           
              <v-card-subtitle
                >Bij elke bestelling krijg je een stempel. Heb je een volle kaart dan
                krijg je een gratis snack of drankje. Als je een actiecode voor gratis stempelkaarten hebt ontvagen kun je die hieronder inwisselen.</v-card-subtitle
              >
              <center class="mb-5">
                 <v-expand-transition>
              <collect-code show v-if="showCode" @success="showCode=false" :size="5" text="Klik hier" placeholder="_ _ _ _ _ _ _ _ _" class="mt-5">
             </collect-code>
              <v-btn text color="primary" @click="showCode=true" v-else>Actiecode invoeren</v-btn>
            
              </v-expand-transition>
              </center>
              <v-row no-gutters>
                <v-col :cols="largeScreen ? 6 : 12" v-for="(host, i) in stamps" :key="'t' + host._id + i">
                <organisation-card class="mx-3 mb-3"
                  
                  :dark="dark"
                  :search="search ? true : false"
                  :deliver="type == 'deliver'"
                  
                  :value="host"
                  flat
                  outlined
                  show-stamps
                  :distance="host.distance"
                  @select="openHost($event)"
                ></organisation-card>
                </v-col>
              </v-row>
                <!--stamp
                        v-for="(stamp, i) in stamps"
                        :key="'stamp' + i"
                        :value="stamp"
                        :text="stamp.name"
                        class="mr-2"
                      >
                      </stamp-->
                <empty
                  :dark="dark"
                  v-if="stamps.length == 0"
                  icon="savings"
                  description="Je hebt geen stempels. <br>Zoek je favoriete restaurant en doe je eerste bestelling."
                ></empty>
            </v-window-item>
            <v-window-item>
               
              
                <v-list class="pa-0 card-list rounded-lg"> 
               <v-divider v-if="orderlist.length > 0"></v-divider>
                <template v-for="order in orderlist">
                  
                <order-card tile
                  :dark="dark"
                  :key="order._id"
                  :order="order"
                  @select="selectOrder"
                ></order-card>
                
                </template>
                </v-list>
                <empty
                  :dark="dark"
                  v-if="orderlist.length == 0"
                  icon="mdi-silverware"
                  description="Je hebt nog geen bestellingen gedaan. <br>Zoek je favoriete restaurant en doe je eerste bestelling."
                ></empty>
            </v-window-item>
            <v-window-item>
              <v-card-title
            
            
            >Steun je lokale verenigingen</v-card-title
          >
              <v-card-text class="mt-0 mb-5">
                Ook het verenigingsleven heeft een zware periode achter de rug. Als
                veel mensen een kleine bijdrage doen, maakt dit een groot verschil.
                Eetplein zorgt voor een eerlijke verdeling of kies zelf een
                vereniging.
              </v-card-text>
              <empty
                :dark="dark"
                v-if="clublist.length == 0"
                icon="hub"
                description="Er zijn nog geen verenigingen aangemeld. "
              ></empty>
              <template v-for="(host, i) in clublist">
                <club-card
                  :dark="dark"
                  :key="'as' + host._id + i"
                  class="mx-3 mb-5"
                  :value="host"
                  flat
                  outlined
                  @select="openClub"
                ></club-card>
              </template>
              <add-host v-model="showAddClub" type="CLUBS" @success="addHostToList"></add-host>
              <center  class="mt-5"><v-btn @click="showAddClub=true" text color="grey">Meld je eigen/favoriete vereniging aan</v-btn></center>
            </v-window-item>
            
            <v-window-item> </v-window-item>
          </v-window>
        </v-card>
      </v-col>
      </v-row>
      </v-container>
    </template>
  </v-sheet>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PageHeader from "../components/PageHeader.vue";
import MainMenu from "../components/MainMenu.vue";
import Couriers from "../components/Couriers.vue";
import FooterInfo from "../components/FooterInfo.vue";
import Onboarding from "../components/Onboarding.vue";
import TypeCard from "../components/TypeCard.vue";
import OrganisationCard from "../components/OrganisationCard.vue";
import AddressSelect from "../components/AddressSelect.vue";
import HubCard from "../components/HubCard.vue";
import ClubCard from "../components/ClubCard.vue";
import OrderCard from "../components/OrderCard.vue";
import locationService from "@/modules/locationService";
import headerItem from "@/modules/headerItem";
import empty from "@/components/empty";

import stamp from "@/components/stamp";
import Eetplein from "@/components/Eetplein";
import AddressBlock from "../components/AddressBlock.vue";
import CollectCode from "../components/CollectCode.vue";
import addHost from "../components/addHost.vue";
export default {
  mixins: [locationService, headerItem],
  components: {
    PageHeader,
    MainMenu,
    Onboarding,
    TypeCard,
    FooterInfo,
    OrganisationCard,
    HubCard,
    ClubCard,
    OrderCard,
    Eetplein,
    stamp,
    empty,
    AddressBlock,
    CollectCode,
    AddressSelect,
    Couriers,
    addHost
  },
  data() {
    return {
      loading: true,
      model2: null,
      showSearch: false,
      drawer: false,
      search: null,
      browse: false,
      showAddressBlock: false,
      showAddress: false,
      showAllDeliveries: false,
      showAddHost: false,
      showAddClub: false,
      showCode: false,
      hublist: [],
      hostlist: [],
      searchList:[],
      favoritelist:[],
      timer: null,
      codeActive: false,
      menuSwiperOptions: {slidesPerView: 'auto', spaceBetween: 0, freeMode:true}
    }
  },
  computed: {
    ...mapGetters(["hub", "orders", "credits", "user",'store','storelist', 'clubs','test','config','deliveries', 'courier']),
    swiper() {
      if (!this.$refs.mySwiper) return false;
      return this.$refs.mySwiper.$swiper;
    },
    swiperOptions() {
      
      return {
          slidesPerView: this.discounts.length > 1 ? 1.1 : 1,
          spaceBetween: 10,

          freeMode: true,
          loop: false,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        // Some Swiper option/callback...
        }
    },
    model: {
     get() {
        return this.$store.state.config.model || 'favorite';
      },
      set(value) {
        this.setConfig({ model: value });
      }
    },
    selectedHub: {
      get() {
        return this.hub;
      },
      set(value) {
        this.setHub(value);
      },
    },
    clublist: {
      get() {
        let clublist = this.clubs || []
        this.hostlist.filter(host=>host.type.includes('club')).map(host=>{
          clublist = clublist.filter(c=>c._id!=host._id)
          clublist.push(host)
        });
        return clublist;
      },
      set(value) {
        this.setClubs(value);
      },
    },
    banner() {
      if (this.loading) return null;
      if (!this.hub) return this.$config.page.banner;
      return this.hub.banner;
    },
    title() {
      let c = this.courier ? 1 : 0
      if (this.tabs == 1 + c) return "Stempels";
      if (this.tabs == 2+ c) return "Bestellingen";
      if (this.tabs == 3 + c) return "Verenigingen";
      if (this.tabs == 0 && this.courier) return null;//"Ophaalservice";
      return null
    },
    titleIcon(){
      let c = this.courier ? 1 : 0
      if (this.tabs == 1 + c) return "savings";
      if (this.tabs == 2 + c) return "list";
      if (this.tabs == 3 + c) return "hub";
      if (this.tabs == 0 && this.courier) return null;//"mdi-bike-fast";
    },
    signname() {
      if (this.hub) return this.hub.name;
      if (this.address) return this.address.city;
      return null;
    },
    addressList() {
      let list = []
      if (this.$store.state.user && this.$store.state.user._address)  
      this.$store.state.user._address.map(a=>{
        list.push(a.city.toLowerCase())
        list.push(a.zipcode.substring(0,4))
      })
      if (this.address) {
        if (this.address.city) list.push(this.address.city.toLowerCase())
        if (this.address.zipcode) list.push(this.address.zipcode.toLowerCase().substring(0,4))
      }
      return list || [];
    },
    subtitle() {
      if (!this.address) return null;
      return this.address.name;
    },
    orderlist() {
      //let hosts = this.searches.map(h=>h._id)
      return this.orders.filter(o=>o._customer._id==this.user._id);
      //if (this.model == "all") return this.orders.filter(o=>o._customer._id==this.user._id);
      //return this.orders.filter((o) => o._customer._id==this.user._id && hosts.includes(o._host._id));
    },
    ordernow(){
        if (this.model !== "favorite") return []
        return this.orders.filter(order=>!order.done && this.$moment(order.date).isSame(this.$moment(), 'day') );
    },
    stamps() {
      let stamps = this.hostlist.filter((s) => s._stamps != 0).sort((a,b)=>{
        if (a._stamps>b._stamps) return -1
        if (a._stamps<b._stamps) return 1
        return 0
        })
        if (this.credits > 0) {
          let mainorder = this.orderlist.filter(o=>o._host._id == 'organisation/bestelinfo')[0]
          if (mainorder) stamps.unshift(Object.assign(mainorder._host, { _stamps: this.credits, _total: mainorder.stamps, _message: mainorder.message, _dense: true}))
        }
        return stamps.filter(s=>s._stamps > 0)
    },
    stampsaction() {
      return this.stamps.filter(
        (s) => s._stamps >= (s.order.stampmax || this.$config.stamps.max)
      );
    },
    menus() {
      if (!this.selectedHub)
        return this.$config.menus;
      let menus = ["favorite", "all"];
      
      this.hostlist.filter(host=>host._hub && host._hub._id==this.selectedHub._id).map((host) => {
        host.type.map((m) => {
          if (!menus.includes(m)) menus.push(m);
        });
      });
      return this.$config.menus.filter(m=>menus.includes(m));
    },
    discounts() {
      let discounts = [];
      this.stampsaction.map((s) => {
        let stamcount = parseInt(s._stamps/(s.order.stampmax || this.$config.stamps.max))
        let stamp = {
          dark: true,
          color: "success",
          name: "Volle kaart",
          stamps: 'true',
          extra: stamcount > 1 ? stamcount + 'x': null,
          description:
            "Gratis snack of drankje bij je volgende bestelling",
          _host: s,
        }
        discounts.push(stamp);
      });
      
      if (this.selectedHub) this.hostlist.filter(host=>(host._hub==this.selectedHub._id || host._favorite) && host._discounts).map((host) => {
        //if (host._discounts)
          host._discounts.map((d) => {
            d._host = this.clone(host);
            discounts.push(d);
          });
      });
      return discounts;
    },
    hosts() {
      let list = []
      if (this.model == "favorite") {
        list = this.favorites
      }else if (this.model == "all") {
          
          list = this.hostlist.filter(host=>(!this.selectedHub || (host._hub && host._hub._id==this.selectedHub._id))).sort(function sortByType(a,b){
            let aIndex=100, bIndex = 100
            try{
            a.type.map(t=>aIndex = self.$config.menus.indexOf(t) < aIndex ? self.$config.menus.indexOf(t): aIndex)
            b.type.map(t=>bIndex = self.$config.menus.indexOf(t) < bIndex ? self.$config.menus.indexOf(t): bIndex)
            }catch(e){}
            return aIndex - bIndex
          }) || [];
      }else {
        list =  this.hostlist.filter(
          (h) => (!this.selectedHub || (h._hub && h._hub._id==this.selectedHub._id)) && (!h.type || h.type.includes(this.model))
        );
       }
       return list.map(h=>{
        h.open = this.isOpen(h.timetable)
        return h
      }).sort(compare)
    },
    favorites(){
      return this.favoritelist.filter(host=>host._favorite && host.type && !host.type.includes('club')) || [];
    },
    /*searches() {
      let searches = [];
      return []
      this.list.map((hub) => {
        searches.push(hub);
        hub._hosts.map((host) => {
          searches.push(host);
        });
      });
      return searches;
    },*/
    isEmpty(){
      if (this.loading) return false
      if (this.selectedHub) return false
      if (this.hublist.length>0) return false
      return true
    },
    address: {
      get() {
        return this.$store.state.config.address || null;
      },
      set(value) {
        this.setConfig({ address: value });
      },
    },
    tabs: {
      get() {
        return this.$store.state.config.tabs;
      },
      set(value) {
        this.setConfig({ tabs: value });
      },
    },
    type: {
      get() {
        return this.$store.state.config.type;
      },
      set(value) {
        this.setConfig({ type: value });
      },
    },
    userAddress() {
      if (
        this.$store.state.user &&
        this.$store.state.user._address &&
        this.$store.state.user._address[0] &&
        this.$store.state.user._address[0].name
      )
        return this.$store.state.user._address[0];
      return null;
    },
  },
  created: async function () {
    this.updateMe();
  },
   destroyed(){
      this.$events.$off()
   },
   beforeMount(){
      if (!this.$store.state.token) return this.$router.push("/");
   },
  async mounted() {
    //console.log('Current Swiper instance object', this.swiper)
    if (!this.orders || !Array.isArray(this.orders)) this.setOrders([]);
    //if (this.swiper) this.swiper.slideTo(3, 1000, false)
    if (this.$store.state.token && !this.address) {
      //if (!this.address)
      this.address = this.userAddress;
      //if (!this.address || !this.address.zipcode)
      //  this.showSearch = !this.isEmpty
      //if (!this.address && !this.selectedHub) return this.tabs = 4
      
    }
    await this.load();
    const self = this
    this.$events.$off()
    this.$events.$on("APP-FOCUS", function(){
      self.loadOrders()
    })
    this.$events.$on('order_modified',self.loadOrders)
  },
  watch: {
    address(value,old) {
      
      //if (value && value.zipcode) this.searchHub(value.zipcode.substring(0, 4));
    },
    isEmpty(value){
      this.showSearch = !value
    },
    model(value) {
      //if (value=='all' && this.list.length >1) this.setHub()
      this.$vuetify.goTo(0, { duration: 600 });
    },
    selectedHub(value, old) {
      if (this.model == "favorite" && old && value && old._id !== value._id) this.model = "all";
    },
    showSearch(value,old){
      if (!old && value) this.tabs = 0
    }
  },
  methods: {
    ...mapActions([
      "setConfig",
      "resetCart",
      "setHub",
      "setHost",
      "setClub",'setClubs',
      "setOrders",
      "addCartItem",
      "logout",
      "login",
      "setUser",
      'toggleFavoriteHub'
    ]),
    closeSearch(address){
      this.showSearch = false
      if (address) this.address = address
      this.reloadMe()
    },
    setCodeActive(value){
      this.codeActive=value
      this.showCode = false
    },
    selectAddress(address){
      this.type ="takeaway";
      if (address && address.zipcode){
        this.address = address
        this.showSearch = false
        this.type ="deliver";
        let hub = this.hublist.filter(hub=>hub.region && (hub.region.includes(address.zipcode.substring(0, 4)) || hub.region.includes(address.city.toLowerCase())))[0]
        if (hub) this.showHub(hub)
      }
    },
    toSlide(index) {
      this.swiper.slideTo(index, 0);
    },
    filterHub(hub) {
      //this.setSelectedHub = hub;
      this.$vuetify.goTo(0);
      this.model = "favorite";
    },
    appendHub(hub){
        if (!hub) return false
        if (hub._clubs && hub._id==this.selectedHub._id) hub._clubs.map((club) => {
          club._hub = hub._id
           this.clublist.push(club);
        })
        if (hub._hosts && hub._id==this.selectedHub._id) hub._hosts.map((host) => {
          host._hub = {_id: hub._id, name: hub.name}
          this.addHostToList(host)
        });
        
        if (hub._hosts.length>0){
          hub._hosts = hub._hosts.map(h=>h._id)
          this.hublist.push(hub)
        }
        if (this.favorites.length==0) this.model = 'all'
    },
    async load() {
      this.resetCart();
      this.setHost();
      this.setClub();
     this.loading = true;
     let hub
     await this.loadFavorites()
     if (this.favorites.length>0){
       hub = this.favorites[0]._hub
     }
     await this.loadOrders();
     if (this.orders.length>0){
       let host = this.favorites.filter(f=>f._id == this.orders[0]._host._id)[0]
       if (host) hub = host._hub
     }
     this.setHub(hub);
     await this.reloadMe()
     this.model = "favorite"
     setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    addHostToList(host){
      let h = this.hostlist.filter(h=>h._id==host._id)[0] || {}
      this.hostlist = this.hostlist.filter(h=>h._id!=host._id)
      this.hostlist.push(Object.assign(h,host))
    },
    async loadFavorites(){
      try{
       let response = await this.$http.get("/api/host/favorites");
        this.favoritelist = response.data
        /*response.data.map((host) => {
          if (host){
            //host._hub = {_id: null}
            this.addHostToList(host)
          }
        })*/
      }catch(e){}
    },
    async reloadMe(silent){
      this.hublist = []
      this.hostlist = this.favorites
      let options = {region: this.addressList || []}
      
      if (this.selectedHub) {
        if (this.selectedHub.region) options.region = options.region.concat(this.selectedHub.region);
        options.region.push(this.selectedHub.name.toLowerCase())
        options.hub = this.selectedHub._id
      }
        let hubs = await this.loadHub(options,silent);
        if (!this.hub || hubs.length==1) {
            this.selectedHub = hubs[0]
            //this.model='all'
         }
        hubs.map((hub) =>this.appendHub(hub))
        
      if (!this.address || !this.selectedHub) this.showAddress = true;
      
    },
    async loadOrders() {
      //if (this.orders && this.orders.length>0) return false
      let response = await this.$http.post("/api/order/list", {});
      this.setOrders(response.data);
    },
    
    async toggleFavorite() {
      if (!this.selectedHub) return false
      this.toggleFavoriteHub()
      if (this.selectedHub._favorite) {
        let response = await this.$http.post(
          "/api/edge/CONSUMERS/" + this.selectedHub._id,
          { _id: this.user._id, favorite: true, date: new Date() }
        );
      } else {
        let response = await this.$http.delete(
          "/api/edge/CONSUMERS/" + this.selectedHub._id,
          { _id: this.user._id }
        );
      }
    },
    async loadHub(options, silent) {
      let response = await this.$http.post("/api/host/list", options);
      setTimeout(() => {
        this.loading = false;
      }, 500);
      return response.data.map((hub) => {
        hub._hosts.map((host) => {
          if (this.address) {
            let aa = this.setAddress(host.regions, host._address, this.address);
            host.allow = !this.address || aa.allow;
            host.distance = aa.distance;
            host.price = aa.price;
            //} else if (this.type!='deliver'){
            // host.allow = true
          }
        });
        return hub;
      });
    },
    getGroupName(type) {
      //if (type=='all' && this.selectedHub) return this.selectedHub.name
      return this.$config.menu[type].title;
    },
    setResetAddress() {
      if (!this.userAddress) return this.resetAddress();
      //return this.model='all'
    },
    resetAddress() {
      this.address = false;
      this.showAddress = true;
    },
    selectDiscount(discount) {
      if (discount.deliver !== null)
        this.type = discount.deliver ? "deliver" : "takeaway";
      let host = this.hostlist.filter(h=>h._id == discount._host._id)[0]
      this.openHost(host, {
        tab: discount.tab,
        group: discount.group,
      });
    },
    selectOrder(order) {
      this.type = order.deliver ? "deliver" : "takeaway";
      order._items.map((product) => {
        console.log(product)
        if (product._id.indexOf("location") == -1 && product.tab !='extra') this.addCartItem(product);
      });
      let host = this.hostlist.filter(h=>h._id == order._host._id)[0]
      this.setConfig({ description: order.description});
      this.openHost(host, { cart: true });
    },
    setHubHost(host) {
      let hub =
        host._hub ||
        this.hublist.filter(
          (hub) => hub._hosts.filter((h) => h._id == host._id).length > 0
        )[0];
      host = hub._hosts.filter((h) => h._id == host._id)[0];
      this.setHost(host);
      this.setHub(hub);
    },
    openHost(host, query) {
      this.setHost(host);
      return this.$router.push({ path: "/" + host._id, query });
    },
    showHub(hub) {
      if (hub && this.hublist.filter(h=>h._id==hub._id).length == 0) this.appendHub(hub)
      //console.log(this.addressList, this.hublist)
      this.selectedHub = hub;
      this.showSearch = false;
      this.showAddressBlock = hub ? false : true;
      this.search = null;
      this.tabs = 0;
      this.model = "all";
    },
    openClub(club) {
      this.setClub(club);
      //return this.$router.push({ path: "/" + club._id.replace('organisation','club') });
    },
    
    async updateMe() {
      //this.loading = true;
      if (!this.$store.state.token) return this.$router.push("/");
      try {
        let response = await this.$http.get("/api/auth/me");
        if (!response.data.user) return this.handleLogout();
        this.setUser(response.data.user);
        
      } catch (e) {
        console.log(e);
        return this.handleLogout();
      }
    },
     isOpen (timetable,date){
       if (!timetable) return false
      if (!date) date = new Date()
      timetable = timetable.filter(t=>t.day==this.$moment(date).format('dddd'))
      if (!timetable || timetable.length==0) return false
      var format = 'hh:mm'
      var time = this.$moment(date, format),
      beforeTime = this.$moment(timetable[0].start, format),
      afterTime = this.$moment(timetable[0].end, format);
      if (afterTime.isBefore(beforeTime)) afterTime.add(1, 'days')
      return time.isBetween(beforeTime, afterTime)
    },
    handleLogout() {
      this.loading = false;
      this.logout();
      this.$router.push("/");
    },
  },
};
function compare(a, b) {
  if (a.open && !b.open) {
    return -1;
  } else {
    return 1;
  }
  // a must be equal to b
  return 0;
}
function append(item,arr, key){
  if (!key) key == '_id'
  let found= false
  arr.map(el=>{
    if (el[key] == item[key]) {
      found = true
      return key
    }
    return el
  })
  if (!found) arr.push(item)
  return arr
}



</script>
<style>
.theme--dark.v-chip--active:hover::before,
.theme--dark.v-chip--active::before {
  display: none;
}
.masonry-with-columns {
  columns: 2 300px;
  column-gap: 20px;
}
@media only screen and (min-width: 800px) {
  .masonry-with-columns {
   
  }
.masonry-with-columns div.v-card--link {
    width:100%;
    display: inline-block;
    margin: 0 0 30px 0!important;
  } 
}
</style>
